export default [
  {
    path: '/activity-20251013-main',
    component: () => import('./Page.vue'),
    meta: { title: '飞车升级' },
  },
  {
    path: '/activity-20251013-rank',
    component: () => import('./Rank.vue'),
    meta: { title: '飞车升级-榜单' },
  },
]
